export class Clasificacion {
    constructor(
        public clasId : number,
        public codigo : string,
        public descripcion : string,
        public rutaS3 : string,
        public selected : boolean = false
    ){}
}
